import { Form, FormDate, FormInput, FormSwitch } from 'metrix-common3';
import { useEffect } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import Helper from '../../../../helpers';

const ProfileApplicantVitals = (props) => {
    const intl = useIntl();

    // biome-ignore lint/correctness/useExhaustiveDependencies: mount-only init
    useEffect(() => {
        const pageHasTooltipInfo =
            props.tooltipInfo?.pages?.length && props.tooltipInfo.pages.some((p) => p.code === props.pageCode);
        if (!pageHasTooltipInfo) {
            props.doGetTooltipInfo(props.policy.product);
        }
    }, []);

    const allowDateEdit = props.policySummary?.type !== 'endorsement';

    const brokerage = Helper.GetBrokerageName(
        props?.policy?.participants?.brokerCompany?.company?.commercialName?.name,
    );
    const assignedTo = Helper.GetBrokerName(
        props?.policy?.participants?.broker?.party?.name?.firstName,
        props?.policy?.participants?.broker?.party?.name?.lastName,
    );
    return (
        <>
            <Form
                pageCode={props.pageCode}
                sectionCode='partyStats'
                saveTooltipInfo={() => props.doUpsertTooltipInfo(props.policy.product)}
                reduceTooltipInfoElement={props.doReduceTooltipInfoElement}
                tooltipInfo={props.tooltipInfo}
                validationInfo={props.validationInfo}
                header={<FormattedMessage id='Profile_Policy_Vitals.partyStats' />}
                label={<FormattedMessage id='Profile_Policy_Vitals.partyDetails' />}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
            >
                <FormInput
                    label={<FormattedMessage id='Profile_Policy_Vitals.partyBrokerage' />}
                    value={brokerage}
                    changeEvent={(_value) => null}
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Policy_Vitals.partyAssignedTo' />}
                    value={assignedTo}
                    changeEvent={(_value) => null}
                />
            </Form>

            <Form
                pageCode={props.pageCode}
                sectionCode='vitalStats'
                saveTooltipInfo={() => props.doUpsertTooltipInfo(props.policy.product)}
                reduceTooltipInfoElement={props.doReduceTooltipInfoElement}
                tooltipInfo={props.tooltipInfo}
                validationInfo={props.validationInfo}
                header={<FormattedMessage id='Profile_Policy_Vitals.vitalStats' />}
                label={<FormattedMessage id='Profile_Policy_Vitals.policyDetails' />}
                saveEvent={() => props.doUpsertPolicy()}
                cancelEvent={() => props.doGetPolicy()}
                allowEdit={props.allowEdit}
            >
                <FormInput
                    label={<FormattedMessage id='Profile_Policy_Vitals.description' />}
                    value={props.policy?.description}
                    changeEvent={(value) => props.doReducePolicyElement({ code: 'description', value })}
                    allowEdit
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Policy_Vitals.submissionReference' />}
                    value={props.policy?.submission?.referenceNumber}
                    changeEvent={(value) => props.doReducePolicyElement({ code: 'submission.referenceNumber', value })}
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Policy_Vitals.policyNumber' />}
                    value={props.policy?.number}
                    changeEvent={(value) => props.doReducePolicyElement({ code: 'number', value })}
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Policy_Vitals.product' />}
                    value={props.policy && props.policySummary?.productName}
                    changeEvent={(_value) => null}
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Policy_Vitals.type' />}
                    value={Helper.getDescription(intl, props.policy?.type, 'policyTypeDescription')}
                    changeEvent={(_value) => null}
                />
                <FormInput
                    label={<FormattedMessage id='Profile_Policy_Vitals.status' />}
                    value={Helper.getDescription(intl, props.policy?.status, 'policyStatusDescription')}
                    changeEvent={(_value) => null}
                />
                {props.policy?.status === 'lost' && props.policy?.quote?.lostReason?.value && (
                    <FormInput
                        label={<FormattedMessage id='Profile_Policy_Vitals.lostReason' />}
                        value={`${props.policy.quote.lostReason.value}`}
                        changeEvent={(_value) => null}
                    />
                )}
                <FormDate
                    fieldCode='effectiveDate'
                    label={<FormattedMessage id='Profile_Policy_Vitals.effectiveDate' />}
                    value={props.policy?.effectiveDate}
                    changeEvent={(value) => props.doReducePolicyElement({ code: 'effectiveDate', value })}
                    culture={props.context.session.culture}
                    allowEdit={allowDateEdit}
                />
                <FormDate
                    fieldCode='expiryDate'
                    label={<FormattedMessage id='Profile_Policy_Vitals.expiryDate' />}
                    value={props.policy?.expiryDate}
                    changeEvent={(value) => props.doReducePolicyElement({ code: 'expiryDate', value })}
                    culture={props.context.session.culture}
                    allowEdit={allowDateEdit}
                />
                {props.policy?.quote?.quoteExpiryDate && (
                    <FormDate
                        label={<FormattedMessage id='Profile_Policy_Vitals.quoteExpiryDate' />}
                        value={props.policy.quote.quoteExpiryDate}
                        culture={props.context.session.culture}
                        allowEdit={false}
                    />
                )}
                <FormSwitch
                    label={<FormattedMessage id='Profile_Policy_Vitals.bindable' />}
                    value={props.policy?.bindable}
                    changeEvent={(value) => props.doReducePolicyElement({ code: 'bindable', value })}
                    allowEdit
                />
                {/*<FormDropDown*/}
                {/*    label={<FormattedMessage id="Profile_Policy_Vitals.billingMethod" />}*/}
                {/*    value={props.policy && props.policy.billingMethod}*/}
                {/*    references={props.reference.references && props.reference.references['BillingMethod']}*/}
                {/*    referencesEvent={() => props.reference.doGetReferences('BillingMethod')}*/}
                {/*    changeEvent={(value) => setAttributeEntity(`${props.dotProp}billingMethod`, value, props.doReducePolicyElement)}*/}
                {/*    allowEdit*/}
                {/*/>*/}
            </Form>
        </>
    );
};

export default ProfileApplicantVitals;
